export const STATE_IDS = {
    START: 'reservationStart',
    FORM: 'reservationForm',
    SUCCESS: 'reservationSuccess',
    ERROR: 'reservationError',
    SMS: 'reservationSMS',
    NOT_ENABLED_ERROR: 'notEnabledError',
    PREVIEW_NOT_ENABLED_ERROR: 'previewNotEnabledError',
    PREVIEW_FORM: 'previewReservationForm',
    PREVIEW_SUCCESS: 'previewReservationSuccess'
};

export const PARAMS_KEYS = {
    SHOW_TITLE_KEY: 'wixseating.title.display',
    SELECTED_TITLE_KEY: 'wixseating.selected.title',
    CUSTOM_TITLE_DATA_KEY: 'wixseating.custom.title',
    SHOW_DESCRIPTION_KEY: 'wixseating.description.display',
    CUSTOM_DESCRIPTION_DATA_KEY: 'wixseating.description',
    SELECTED_BUTTON_KEY: 'wixseating.selected.button',
    CUSTOM_BUTTON_DATA_KEY: 'wixseating.custom.button',
    LAYOUT_KEY: 'wixseating.layout',
    ALIGNMENT_KEY: 'wixseating.alignment',
    SELECTED_PRESET: 'wixseating.selected.preset'
};

export const MODAL_A11Y_IDS = {
    TITLE_ID: 'restaurants-modal-title',
    DESCRIPTION_ID: 'restaurants-modal-description'
}